/* tslint:disable */
/**
 * @export
 * @enum {string}
 */
export var ActivityRecurrenceFrequencyUnitEnum;
(function (ActivityRecurrenceFrequencyUnitEnum) {
    ActivityRecurrenceFrequencyUnitEnum["Day"] = "day";
    ActivityRecurrenceFrequencyUnitEnum["Week"] = "week";
    ActivityRecurrenceFrequencyUnitEnum["Month"] = "month";
})(ActivityRecurrenceFrequencyUnitEnum || (ActivityRecurrenceFrequencyUnitEnum = {}));
